import React, { useMemo } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { paths } from 'src/config/paths'
import { useAuthState } from 'src/shared/features/auth/api/use-auth-state'

interface OnboardingGuardProps {
  children: React.ReactNode
}

export const OnboardingGuard = ({ children }: OnboardingGuardProps) => {
  const { isSignedIn, needsOnboarding } = useAuthState()
  const location = useLocation()

  return useMemo(() => {
    if (isSignedIn && needsOnboarding && !location.pathname.startsWith(paths.auth.onboarding.path)) {
      return <Navigate to={paths.auth.onboarding.getHref()} replace />
    }
    return <>{children}</>
  }, [isSignedIn, needsOnboarding, location.pathname, children])
}
